import {ANONYMOUS_ID_COOKIE_NAME} from '@lightricks/delta-client-js/dist/constants';
import getCookieValue from '@/utils/getCookieValue';

export default function initializeAnonymousIdFromUrl() {
  const cookieValue = getCookieValue(ANONYMOUS_ID_COOKIE_NAME);
  if (cookieValue) {
    return;
  }
  const queryParams = new URLSearchParams(window.location.search);
  const redirectedAnonymousId = queryParams.get('anonymousId');
  if (redirectedAnonymousId) {
    document.cookie = `${ANONYMOUS_ID_COOKIE_NAME}=${redirectedAnonymousId}; path=/`;
  }
}
